export default __webpack_public_path__ + "a0a4addbc7560c5630d87c673a6bc971.jpg";